import React from 'react';
import { PlayerCardRank } from './PlayerCardRank';
import { PlayerCardBio } from './PlayerCardBio';
import { gql } from '@urql/core';
import { PlayerCardContentFragment } from '../../../generated/spin-graphql';
import { PictureWithFallback } from '../../sections/PictureWithFallback';

type Props = {
    className?: string;
    player: PlayerCardContentFragment;
};

gql`
    fragment PlayerCardContent on espin_player_profile {
        spin_username
        profile_image {
            ...FormFile
        }
        ...PlayerCardBio
        ...PlayerCardRank
    }
`;

export const PlayerCardContent: React.FC<Props> = ({ className, player }) => {
    return (
        <div className="player-card-content">
            <div className="player-card-profile-container">
                <div className="player-profile-image">
                    <PictureWithFallback
                        icon={player.profile_image}
                        width={90}
                        height={90}
                        alt={`${player.spin_username}} profile picture`}
                    />
                </div>
                <PlayerCardBio player={player} />
            </div>

            <PlayerCardRank player={player} />
        </div>
    );
};
